import { FilterField, useUserOptions } from "~/features/filter";

import { useEventTypeOptions } from "./model/useEventTypeOptions";

type Translate = (key: string) => string;

/**
 * Поля фильтра логов использования камер: тип события и пользователь —
 * одиночные селекты с серверными опциями, даты — диапазон.
 * Имена полей совпадают с REST-параметрами GET /logs/activity,
 * значения хранятся в URL (даты — строками yyyy-MM-dd).
 */
export const ivideonLogsFilterFields = (t: Translate): FilterField[] => [
  {
    name: "eventType",
    type: "select",
    label: t("logs.logsList"),
    optionsHook: useEventTypeOptions,
  },
  {
    name: "userId",
    type: "select",
    label: t("logs.users"),
    optionsHook: useUserOptions,
  },
  {
    name: "startDate",
    nameTo: "endDate",
    type: "dateRange",
    label: t("logs.date"),
    placeholder: t("employee.defaultDateFrom"),
    placeholderTo: t("employee.defaultDateTo"),
    fixedWidth: 360,
    disableFutureDates: true,
  },
];
